import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import Section from '../shared/Section/Section';
import Container from '../shared/Container/Container';
import ProductCard from '../shared/ProductCard/ProductCard';
import NotifyMeModal from '../shared/NotifyMeModal/NotifyMeModal';
import { products } from '../../data/products';
import './ForPets.css';

const ForPets = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Section background="light" id="for-pets">
        <Container>
          <div className="for-pets" ref={ref}>
            <motion.div
              className="for-pets__header"
              initial={{ opacity: 0, y: 24 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7 }}
            >
              <h2 className="for-pets__title">Bark-n-Dip</h2>
              <p className="for-pets__slogan">
                9 in 6 dogs approve Bark-n-Dip 🐾
              </p>
            </motion.div>

            <div className="for-pets__content">
              <motion.div
                className="for-pets__image"
                initial={{ opacity: 0, x: -50 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8 }}
              >
                <img
                  src="/images/bark_n_dip.png"
                  alt="Bark-n-Dip — a cute paw-sized cup and a rib-shaped bone treat, with a very good boy waiting to dip"
                  className="for-pets__image-main"
                  loading="lazy"
                />
              </motion.div>

              <motion.div
                className="for-pets__text"
                initial={{ opacity: 0, x: 50 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                {products.pets && (
                  <ProductCard
                    product={products.pets}
                    onNotifyClick={() => setIsModalOpen(true)}
                    variant="pets"
                    inView={isInView}
                  />
                )}
              </motion.div>
            </div>
          </div>
        </Container>
      </Section>

      {products.pets && (
        <NotifyMeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          productName={products.pets.name}
          productId={products.pets.id}
        />
      )}
    </>
  );
};

export default ForPets;
